<!-- Common KPI Affected Groups Pop-Up -->
<template>
    <div>
        <v-dialog v-model="affectedGroupsDialog" max-width="900px">
          <v-card>
            <v-card-text>
              <v-container>
                    <v-row>
                        <span v-if="isEditCommonKPIAffectedGroups" style="font-weight: bold;" class="mb-2 mt-6">{{$t('pmcmmkpi.editaffectedgroup')}}</span>
                        <span v-else style="font-weight: bold;" class="mb-2 mt-6">{{$t('pmcmmkpi.addaffectedgroup')}}</span>
                    </v-row>
                    <v-row class="pb-n4 mb-n10">
                        <v-col cols="8" class="pl-0">
                            <v-autocomplete
                                outlined
                                :label="this.$t('columns.company')"
                                type="text"
                                ref="companyid"
                                v-model="formData.companyid"
                                :items="companyList"
                                @input="updateValue"
                                @change="changeCompany(formData.companyid)"
                                dense
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="pl-0">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.companycode"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="pb-n4 mt-n8 mb-n10">
                        <v-col cols="8" class="pl-0">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.branch')"
                                type="text"
                                ref="branchid"
                                v-model="formData.branchid"
                                dense
                                :items="branchList"
                                @input="updateValue"
                                @change="changeBranch(formData.branchid)"
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="pl-0">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.branchcode"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="pb-n4 mt-n8 mb-n10">
                        <v-col cols="8" class="pl-0">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.division')"
                                type="text"
                                ref="compnyid"
                                v-model="formData.divid"
                                dense
                                :items="divisionList"
                                @input="updateValue"
                                @change="changeDivision(formData.divid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="pl-0">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.divisioncode"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="pb-n4 mt-n8 mb-n10">
                        <v-col cols="8" class="pl-0">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.department')"
                                type="text"
                                ref="deptid"
                                v-model="formData.deptid"
                                dense
                                :items="departmentList"
                                @input="updateValue"
                                @change="changeDepartment(formData.deptid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="pl-0">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.departmentcode"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row> 
                    <v-row class="pb-n4 mt-n8 mb-n10">
                        <v-col cols="8" class="pl-0">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.section')"
                                type="text"
                                ref="sectionid"
                                v-model="formData.sectionid"
                                dense
                                :items="sectionList"
                                @input="updateValue"
                                @change="changeSection(formData.sectionid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="pl-0">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.sectioncode"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="pb-n4 mt-n8 mb-n10">
                        <v-col cols="8" class="pl-0">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.unit')"
                                type="text"
                                ref="unitid"
                                v-model="formData.unitid"
                                dense
                                :items="unitList"
                                @input="updateValue"
                                @change="changeUnit(formData.unitid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="pl-0">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.unitcode"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="pb-n4 mt-n8 mb-n10">
                        <v-col cols="8" class="pl-0">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.employmenttype')"
                                type="text"
                                ref="emptypeid"
                                v-model="formData.emptypeid"
                                dense
                                :items="employmentTypeList"
                                @input="updateValue"
                                @change="changeEmploymentType(formData.emptypeid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="pl-0">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.emptypecode"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="pb-n4 mt-n8 mb-n10">
                        <v-col cols="8" class="pl-0">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.grade')"
                                type="text"
                                ref="gradeid"
                                v-model="formData.gradeid"
                                dense
                                :items="gradeList"
                                @input="updateValue"
                                @change="changeGrade(formData.gradeid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="pl-0">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.gradecode"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="pb-n4 mt-n8 mb-n10">
                        <v-col cols="8" class="pl-0">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.job')"
                                type="text"
                                ref="jobid"
                                v-model="formData.jobid"
                                dense
                                :items="jobList"
                                @input="updateValue"
                                @change="changeJob(formData.jobid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="pl-0">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.jobcode"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="pb-n4 mt-n8 mb-n10">
                        <v-col cols="4" sm="4" class="pl-0">
                            <v-text-field
                                outlined
                                :label="$t('pmreviewexercisesectioncard.weightage')"
                                type="number"
                                v-model="formData.weightage"
                                ref="weightage"
                                @input="updateValue"
                                dense
                                class="v-input"
                            ></v-text-field>
                        </v-col>
                    </v-row>
              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="fbtn fbtn-success" @click="saveAffectedGroupsInput">{{$t('button.save')}}</v-btn>
              <v-btn class="fbtn fbtn-cancel" @click="closeProgressKpiInput">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div class="section-block">
            <div class="section-header">
                <span class="section-title">{{$t('pmcmmkpi.affectedgroups')}}</span>
                <v-btn color="primary" dark small @click="openAffectedGroupsInput">+</v-btn>
            </div>
            <v-data-table
                :headers="this.parentObject.tabHeader"
                :items="affectedGroupsCommonKpiListdetail"
                fixed-header
                :sort-by="['code']"
            >
                <template v-slot:[`item.action`]="{ item }">
                    <v-icon small class="mr-1" @click="modifyItemHandler(item)">mdi-pen</v-icon>
                    <v-icon small @click="deleteItemHandler(item)">mdi-delete</v-icon>
                </template>
            </v-data-table>
        </div>

        <div v-if="isErr">
        <app-error
            v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
        />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            publicPath: process.env.BASE_URL,

            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            affectedGroupsCommonKpiListdetail: [],

            kpiaffectedgroupid: null,
            commonkpiid: this.parentObject.formData.commonkpiid,
            formData: {
                ...this.parentObject.formData,
                companyid: null,
                companycode: null,
                branchid: null,
                branchcode: null,
                divid: null,
                divisioncode: null,
                deptid: null,
                departmentcode: null,
                sectionid: null,
                sectioncode: null,
                unitid: null,
                unitcode: null,
                emptypeid: null,
                emptypecode: null,
                gradeid: null,
                gradecode: null,
                jobid: null,
                jobcode: null,
                weightage: null
            },

            companyFull: [],
            companyList: [],
            branchFull: [],
            branchList: [],
            departmentFull: [],
            departmentList: [],
            divisionFull: [],
            divisionList: [],
            sectionFull: [],
            sectionList: [],
            unitFull: [],
            unitList: [],
            employmentTypeFull: [],
            employmentTypeList: [],
            gradeFull: [],
            gradeList: [],
            jobFull: [],
            jobList: [],

            affectedGroupsDialog: false,
            
            //error msg and dialog, check for duplicates vars
            isErr: false,
            isEditCommonKPIAffectedGroups: false,
            errMsg: '',
        }
    },

    methods: {
        modifyItemHandler(item) {
            this.loadKpiProgressHandler(item)
            this.isEditCommonKPIAffectedGroups = true;
            this.affectedGroupsDialog = true;
        },

        loadKpiProgressHandler(item) {
            this.resetFormData();
            this.kpiaffectedgroupid = item.id;
            this.formData = item;
        },

        //load kpi common affected groups list handler
        async loadKpiCommonAffectedGroupsListHandler() {
            const vm = this;

            await this.$store.dispatch('get', {url: "/kpicommonaffectedgroups/" + vm.$route.params.id})
            .then((res) => {
                vm.affectedGroupsCommonKpiListdetail = res.data.rec;
                console.log("affectedGroupsCommonKpiListdetail", vm.affectedGroupsCommonKpiListdetail);
                vm.affectedGroupsCommonKpiListdetail.forEach(item => {
                    if (item.companyid) {
                        const company = vm.companyFull.find(c => c.id === item.companyid);
                        item.companycode = company?.compnycode ?? null;
                    }
                    if (item.branchid) {
                        const branch = vm.branchFull.find(b => b.id === item.branchid);
                        item.branchcode = branch?.brchcode ?? null;
                    }
                    if (item.divid) {
                        const division = vm.divisionFull.find(d => d.id === item.divid);
                        item.divisioncode = division?.divncode ?? null;
                    }
                    if (item.deptid) {
                        const dept = vm.departmentFull.find(d => d.id === item.deptid);
                        item.departmentcode = dept?.deptcode ?? null;
                    }
                    if (item.sectionid) {
                        const section = vm.sectionFull.find(s => s.id === item.sectionid);
                        item.sectioncode = section?.sectiocode ?? null;
                    }
                    if (item.unitid) {
                        const unit = vm.unitFull.find(u => u.id === item.unitid);
                        item.unitcode = unit?.unitcode ?? null;
                    }
                    if (item.emptypeid) {
                        const emptype = vm.employmentTypeFull.find(e => e.id === item.emptypeid);
                        item.emptypecode = emptype?.emptype ?? null;
                    }
                    if (item.gradeid) {
                        const grade = vm.gradeFull.find(g => g.id === item.gradeid);
                        item.gradecode = grade?.grdcode ?? null;
                    }
                    if (item.jobid) {
                        const job = vm.jobFull.find(j => j.id === item.jobid);
                        item.jobcode = job?.jobcode ?? null;
                    }
                });
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        deleteItemHandler(item) {
            const vm = this;
            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }

            if (confirm(this.$t('pmcmmkpi.deleteaffectedgroup'))) {
                this.$store.dispatch('delete', {
                    url: "/kpicommonaffectedgroups/" + item.id + '/' + this.$store.getters.userId
                })
                .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                } else {
                    let itemIndex = this.affectedGroupsCommonKpiListdetail.indexOf(item);
                    this.affectedGroupsCommonKpiListdetail.splice(itemIndex, 1);
                }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
            }
        },

        openAffectedGroupsInput() {
            this.affectedGroupsDialog = true;
        },

        changeCompany(id) {
            let item = this.companyFull.find((item) => item.id === id);
            this.formData.companycode = item.compnycode;
        },

        loadCompanyListHandler() {
            const vm = this;
    
            this.$store.dispatch('get', {url: `/company/allfilter/${this.$store.getters.userId}`})
            .then((res) => {

                vm.companyFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.companyList.push({
                        text: res.data.rec[i].compnyname,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

        changeBranch(id) {
            let item = this.branchFull.find((item) => item.id === id);
            this.formData.branchcode = item?.brchcode ?? null;
        },

        loadBranchListHandler() {
            const vm = this;
    
            this.$store.dispatch('get', {url:  "/branch/notdisable"})
            .then((res) => {
                vm.branchFull = res.data.rec;
    
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.branchList.push({
                        text: res.data.rec[i].brchname,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

        changeDivision(id) {
            let item = this.divisionFull.find((item) => item.id === id);
            this.formData.divisioncode = item?.divncode ?? null;
        },

        loadDivisionListHandler() {
            const vm = this;
    
            this.$store.dispatch('get', {url:  "/division/notdisable"})
            .then((res) => {
                vm.divisionFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.divisionList.push({
                        text: res.data.rec[i].divnname,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

        changeDepartment(id) {
            let item = this.departmentFull.find((item) => item.id === id);
            this.formData.departmentcode = item?.deptcode ?? null;
        },

        loadDepartmentListHandler() {
            const vm = this;
    
            this.$store.dispatch('get', {url:  "/department/notdisable"})
            .then((res) => {
                vm.departmentFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.departmentList.push({
                        text: res.data.rec[i].deptname,
                        value: res.data.rec[i].id,
                    });
                }
                })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

        changeSection(id) {
            let item = this.sectionFull.find((item) => item.id === id);
            this.formData.sectioncode = item?.sectiocode ?? null;
        },

        loadSectionListHandler() {
            const vm = this;

            this.$store.dispatch('get', {url: "/section/notdisable"})
            .then((res) => {
                vm.sectionFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.sectionList.push({
                        text: res.data.rec[i].sectioname,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

        changeUnit(id) {
            let item = this.unitFull.find((item) => item.id === id);
            this.formData.unitcode = item?.unitcode ?? null;
        },

        loadUnitListHandler() {
            const vm = this;

            this.$store.dispatch('get', {url: "/unit/notdisable"})
            .then((res) => {
                vm.unitFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.unitList.push({
                        text: res.data.rec[i].unitname,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

        changeEmploymentType(id) {
            let item = this.employmentTypeFull.find((item) => item.id === id);
            this.formData.emptypecode = item?.emptype ?? null;
        },

        loadEmploymentTypeListHandler() {
            const vm = this;

            this.$store.dispatch('get', {url: "/emptype/notdisable"})
            .then((res) => {
                vm.employmentTypeFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.employmentTypeList.push({
                        text: res.data.rec[i].emptypedesc,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

        changeGrade(id) {
            let item = this.gradeFull.find((item) => item.id === id);
            this.formData.gradecode = item?.grdcode ?? null;
        },

        loadGradeListHandler() {
            const vm = this;

            this.$store.dispatch('get', {url: "/grade/notdisable"})
            .then((res) => {
                vm.gradeFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.gradeList.push({
                        text: res.data.rec[i].grddesc,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

        changeJob(id) {
            let item = this.jobFull.find((item) => item.id === id);
            this.formData.jobcode = item?.jobcode ?? null;
        },

        loadJobListHandler() {
            const vm = this;

            this.$store.dispatch('get', {url: "/job/notdisable"})
            .then((res) => {
                vm.jobFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.jobList.push({
                        text: res.data.rec[i].jobtitle,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

        async saveAffectedGroupsInput() {
            const vm = this;

            if(vm.isEditCommonKPIAffectedGroups) {

                if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                    return false;
                }

                vm.formData.userid = vm.$store.getters.userId;

                await vm.$store.dispatch('put', {url: "/kpicommonaffectedgroups/" + vm.kpiaffectedgroupid, payload: vm.formData})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    }
                    else{
                        vm.isErr = false;
                        vm.resetFormAndReload();
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                });

            } else { //Add New

                if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                    return false;
                }

                await this.$store.dispatch('post', {url: "/kpicommonaffectedgroups/create", payload: vm.formData})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        let item = res.data.rec;

                        vm.affectedGroupsCommonKpiListdetail.push(item);
                        vm.isErr = false;
                        vm.resetFormAndReload();
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                });
            }
        },

        // Method to reset form and reload
        resetFormAndReload() {
            // Reset the form fields
            this.loadKpiCommonAffectedGroupsListHandler();
            this.affectedGroupsDialog = false;
            this.isEditCommonKPIAffectedGroups = false;
            this.resetFormData();
        },

        closeProgressKpiInput() {
            this.isEditCommonKPIAffectedGroups = false;
            this.affectedGroupsDialog = false;
            this.isErr = false;
            console.log("this",this.parentObject);

            // reset the form fields
            this.resetFormData();
        },

        resetFormData() {
            this.formData = {
                commonkpiid: this.commonkpiid,
                companyid: null,
                companycode: null,
                branchid: null,
                branchcode: null,
                divid: null,
                divisioncode: null,
                deptid: null,
                departmentcode: null,
                sectionid: null,
                sectioncode: null,
                unitid: null,
                unitcode: null,
                emptypeid: null,
                emptypecode: null,
                gradeid: null,
                gradecode: null,
                jobid: null,
                jobcode: null,
                weightage: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            }
        },
        
        updateValue() {
            this.$emit('input', {
                commonkpiid: this.commonkpiid,
                companyid: null,
                companycode: null,
                branchid: null,
                branchcode: null,
                divid: null,
                divisioncode: null,
                deptid: null,
                departmentcode: null,
                sectionid: null,
                sectioncode: null,
                unitid: null,
                unitcode: null,
                emptypeid: null,
                emptypecode: null,
                gradeid: null,
                gradecode: null,
                jobid: null,
                jobcode: null,
                weightage: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            });
        },
    },
    mounted() {
        this.loadCompanyListHandler();
        this.loadBranchListHandler();
        this.loadDivisionListHandler();
        this.loadDepartmentListHandler();
        this.loadSectionListHandler();
        this.loadUnitListHandler();
        this.loadEmploymentTypeListHandler();
        this.loadGradeListHandler();
        this.loadJobListHandler();
        this.loadKpiCommonAffectedGroupsListHandler();
        
    }
}
</script>

<style scoped>
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
.section-block {
    border-top: 1px solid #E8EDF5;
    padding-top: 4px;
    margin-bottom: 8px;
}
.section-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 4px;
}
.section-title {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #5C6BC0;
}
</style>